import classNames from 'classnames';
import { useEffect, useState } from 'react';

import ConditionalWrapper from '~components/ConditionalWrapper/ConditionalWrapper';
import { useAppDispatch, useAppSelector } from '~hooks/useRedux';
import useWindowSize from '~hooks/useWindowSize';
import greenCheckmark from '~images/common/circle-green-checkmark.svg';
import disabledCheckmark from '~images/common/disabled-checkmark.svg';
import ChevronSmall from '~images/inline/chevron-small.inline.svg';
import { updateNtmActiveStep, updateNtmVisited } from '~redux/Actions/GlobalActions';

const StepNavigation = ({
    activestep,
    children,
}: React.PropsWithChildren<{ activestep: string }>) => {
    const dispatch = useAppDispatch();
    const { width } = useWindowSize();
    const [isOpen, setIsOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const ntmActiveStep = useAppSelector((state) => state.global.ntmActiveStep);
    const ntmVisited = useAppSelector((state) => state.global.ntmVisited);

    useEffect(() => {
        dispatch(updateNtmActiveStep(activestep));

        if (!ntmVisited.includes(activestep)) {
            dispatch(updateNtmVisited(activestep));
        }
    }, []);

    useEffect(() => {
        setIsDesktop(width >= 1024);
    }, [width]);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="step-navigation relative shadow-lg">
            <button
                type="button"
                aria-label="toggle navigation"
                className="flex items-center bg-white justify-between text-left w-full px-4 py-8 text-lg font-bold lg:hidden"
                onClick={toggleMenu}
            >
                <div className="flex items-center">
                    <img
                        src={ntmActiveStep ? greenCheckmark : disabledCheckmark}
                        alt=""
                        width="20"
                        height="20"
                        className="mr-2"
                    />
                    {ntmActiveStep}
                </div>
                <ChevronSmall className="rotate-90" />
            </button>
            <ConditionalWrapper
                condition={!isDesktop}
                wrapper={(children) => (
                    <div
                        className={
                            isOpen
                                ? 'block bg-white w-full border-t border-gray-light md:border-t-0 shadow-lg absolute lg:relative top-0 z-20'
                                : 'hidden'
                        }
                    >
                        {children}
                    </div>
                )}
            >
                <ol
                    className={classNames(
                        'max-w-screen-xl mx-auto flex flex-col justify-between lg:flex-row',
                        'py-4 md:px-2',
                        isOpen && 'relative'
                    )}
                >
                    {isOpen && (
                        <button
                            className={classNames(
                                'p-4 lg:hidden',
                                isOpen && 'absolute top-0 right-0 mt-6'
                            )}
                            onClick={toggleMenu}
                        >
                            <ChevronSmall className="-rotate-90" />
                        </button>
                    )}
                    {children}
                </ol>
            </ConditionalWrapper>
        </div>
    );
};

export default StepNavigation;
